/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { Client } from 'fierry/flux';

import SelectTypeEnum from 'shared/enum/select.type';

import Url from 'shared/client/url';
import Config from 'shared/query/config'

import DefaultView from 'shared/client/behavior/base'


export default new Client ([ Url, Config ], class
{
  constructor (url, config)
  {
    this.url = url;
    this.config = config.behavior;
  }


  canNavigate (route = null)
  {
    return this.__getView__(route).canNavigate();
  }


  canSelect (route = null)
  {
    return this.__getView__(route).canSelect();
  }


  getSelectAlgorithm (route = null)
  {
    return this.__getView__(route).getSelectAlgorithm();
  }


  getSelectStyle (route = null)
  {
    return this.__getView__(route).getSelectStyle();
  }


  getSelectType (route = null)
  {
    return this.__getView__(route).getSelectType();
  }


  getSelectValueCount (current, target, galaxy, route = null)
  {
    return this.__getView__(route).getSelectValueCount(current, target, galaxy);
  }


  getSelectRange (galaxy, route = null)
  {
    return this.__getView__(route).getSelectRange(galaxy);
  }


  getSelectShape (current, galaxy, route = null)
  {
    return this.__getView__(route).getSelectShape(current, galaxy);
  }


  getSelectInitialTargets (current, galaxy, route = null)
  {
    return this.__getView__(route).getSelectInitialTargets(current, galaxy);
  }


  canSelectZone (route = null)
  {
    return this.getSelectType(route) & SelectTypeEnum.Zone;
  }


  canSelectDock (route = null)
  {
    return this.getSelectType(route) & SelectTypeEnum.Dock;
  }


  canSelectPlatform (route = null)
  {
    return this.getSelectType(route) & SelectTypeEnum.Platform;
  }


  canSelectGalaxy (route = null)
  {
    return this.getSelectType(route) & SelectTypeEnum.Galaxy;
  }


  isPaneCollapsed (route = null)
  {
    return this.__getView__(route).isPaneCollapsed();
  }


  __getView__ (route)
  {
    if (route == null)
    {
      route = this.url.getRoute();
    }

    let View = this.config[route.getType()];

    if (View == null)
    {
      View = DefaultView;
    }

    return new View(route.getArgs());
  }


});
